export const splitKeys = {
    name: ["prefix", "first", "middle", "last", "suffix", "otherNames"],
    company: ["name", "suffix", "suffixFull"],
    date: ["year", "month", "day", "hour", "minute", "second"],
    email: ["username", "domain"],
    currency: ["numberValue", "symbol", "name", "code", "usd"],
    notes: ["secondaryKeywords", "extraKeywords"],
    phone: ["countryCode", "areaCode", "number"]
}